import { Alert, Snackbar } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BriaIconButton from "../../../../components/common/BriaIconButton/BriaIconButton";
import { useAppStore } from "../../../../hooks/useStores";
import { CampaignEntityStatus } from "../../../../models/common";
import upload from "../../../assets/svgs/upload.svg";
import { Template, defaultTemplate } from "../../../models/template";
import styles from "./CampaignJsonImportButton.module.scss";
interface CampaignJsonImportButtonProps {
	onImport: (data: any) => void;
	isLoading: boolean;
}

const CampaignJsonImportButton: React.FC<CampaignJsonImportButtonProps> = ({ onImport, isLoading }) => {
	const inputFileRef = useRef<HTMLInputElement>(null);
	const { t } = useTranslation("translation", { keyPrefix: "editor.header" });
	const [importJsonErrorSnackbarOpen, setImportJsonErrorSnackbarOpen] = useState<boolean>(false);
	const { campaignStore } = useAppStore();

	const handleImportTemplate = useCallback(
		async (data: any) => {
			onImport(data);
		},
		[onImport],
	);

	const handleInputFileRefClick = () => {
		inputFileRef.current?.click();
	};

	const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (file) {
			const reader = new FileReader();
			reader.onload = (res) => {
				try {
					const result = res.target?.result as string;
					const design = JSON.parse(result);
					handleImportTemplate(design);
					const newTemplate: Template = {
						...defaultTemplate,
						ads_json: design,
						status: CampaignEntityStatus.ACTIVE,
					};
					campaignStore.selectedTemplate = newTemplate;
				} catch (error) {
					setImportJsonErrorSnackbarOpen(true);
				}
			};
			reader.onerror = (err) => console.error("File reading error:", err);
			reader.readAsText(file);
		}
	};

	const handleCloseSnackbar = () => {
		setImportJsonErrorSnackbarOpen(false);
	};

	return (
		<>
			<input
				className={styles.hiddenInput}
				type="file"
				ref={inputFileRef}
				accept=".json,application/json"
				multiple={false}
				onChange={handleFileInput}
			/>
			<BriaIconButton
				disabled={isLoading}
				title={t("import")}
				loading={isLoading}
				buttonType="secondaryLarge"
				onClick={handleInputFileRefClick}
			>
				<img src={upload} />
			</BriaIconButton>
			<Snackbar open={importJsonErrorSnackbarOpen} autoHideDuration={2000} onClose={handleCloseSnackbar}>
				<Alert onClose={handleCloseSnackbar} severity="error">
					{t("jsonImportError")}
				</Alert>
			</Snackbar>
		</>
	);
};

export default CampaignJsonImportButton;
